<div class="wrapper">
    <app-humi-logo size="medium"></app-humi-logo>
    <h1>Server Error</h1>
    <p>Oops. It looks like something went wrong.</p>
    <ui-button type="primary" [url]="'/'">Return Home</ui-button>
</div>
